export const SET_DYNAMIC_BREADCRUMS = '@@CONFIGURATION/SET_DYNAMIC_BREADCRUMS';
export const SET_FEATURES = '@@CONFIGURATION/SET_FEATURES';
export const SET_VIRUS_SCAN_STATUS = '@@CONFIGURATION/SET_VIRUS_SCAN_STATUS';
